import { cx } from '@emotion/css';
import type { FC } from 'react';

import { dataSetToAttributes } from '../../utils';
import { testIds } from './GlobalHeader.constants';
import {
  globalHeaderCtaMobileCss,
  globalHeaderMobileBottomBorderCss,
  globalHeaderMobileCss,
  globalHeaderMobileNavButtonCss,
} from './GlobalHeader.styles';
import { GlobalHeaderAnimatedIcon } from './GlobalHeaderAnimatedIcon/GlobalHeaderAnimatedIcon';
import { testIds as navScreenTestIds } from './GlobalNavScreen/GlobalNavScreen.constants';
import type { GlobalHeaderMobileProps } from './types';

export const GlobalHeaderMobile: FC<GlobalHeaderMobileProps> = ({
  logo,
  cta,
  className,
  isExpanded,
  toggleExpanded,
  showNavScreen,
  endChildrenClassName,
  buttonAriaLabel,
  dataset,
  addBottomBorder,
}) => (
  <header
    className={cx(
      globalHeaderMobileCss,
      addBottomBorder && globalHeaderMobileBottomBorderCss,
      className
    )}
    {...dataSetToAttributes(dataset)}
  >
    {showNavScreen && (
      <button
        onClick={toggleExpanded}
        className={globalHeaderMobileNavButtonCss}
        data-testid={isExpanded ? navScreenTestIds.closeButton : testIds.openButton}
        aria-label={buttonAriaLabel}
      >
        <GlobalHeaderAnimatedIcon />
      </button>
    )}
    {logo}
    <aside
      className={endChildrenClassName ?? globalHeaderCtaMobileCss}
      data-testid={testIds.endContents}
    >
      {cta}
    </aside>
  </header>
);

GlobalHeaderMobile.displayName = 'GlobalHeaderMobile';
